module.exports = __webpack_public_path__ + "img/6.075a11a1.png";